import React from "react";
import Categories from "./components/categories";
import Search from "./components/search";
import { SettingsContext } from "./components/settingContext";
import "./App.css";

function App() {
  const settings = React.useContext(SettingsContext);
  if (settings.widget === "category") {
    return (
      <div className="crop-app-index category" data-widget="category">
        <Categories />
      </div>
    );
  } else {
    return (
      <div className="crop-app-index search" data-widget="search">
        <Search />
      </div>
    );
  }
}

export default App;
